import React from 'react'
import Modal from '@berlitz/modal'
import { RichText, TextAlign } from '@berlitz/globals'

const FormModal = ({ open, handleClose, modalContent }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <TextAlign align="center">
        <div data-key="lead-success-modal__wrapper">
          <RichText
            data-key="lead-success-modal__content"
            dangerouslySetInnerHTML={{ __html: modalContent }}
          />
        </div>
      </TextAlign>
    </Modal>
  )
}

export default FormModal
